import { useEffect, useMemo, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const FillterButton = () => {
  const [progress, setProgress] = useState(0);
  const viewportRef = useRef<HTMLDivElement>(null);

  const navigate = useNavigate();

  const buttonData = [
    {
      label: '경매신건',
      imgSrc: '/assets/images/main/icon_newauction.svg',
      onClick: () => {
        navigate('/NewAuction');
      },
    },
    {
      label: '예정물건',
      imgSrc: '/assets/images/main/icon_expected.svg',
      onClick: () => {
        navigate('/scheduledAuction');
      },
    },
    {
      label: '최근2주변동',
      imgSrc: '/assets/images/main/icon_change.svg',
      onClick: () => {
        navigate('/search?type=c&specialCondition=최근 2주 변동 물건');
      },
    },
    {
      label: '법정지상권',
      imgSrc: '/assets/images/main/icon_statutory.svg',
      onClick: () => {
        navigate('/search?type=c&specialCondition=법정지상권');
      },
    },
    {
      label: '감정1년후',
      name1: '감정',
      name2: '1년후물건',
      imgSrc: '/assets/images/main/icon_year.svg',
      onClick: () => {
        navigate('/search?type=c&specialCondition=감정시점 1년 경과 물건');
      },
    },
    {
      label: '유치권',
      imgSrc: '/assets/images/main/icon_lien.svg',
      onClick: () => {
        navigate('/search?type=c&specialCondition=유치권');
      },
    },
    {
      label: '공시1억이하',
      imgSrc: '/assets/images/main/icon_below.svg',
      onClick: () => {
        navigate('/search?type=c&specialCondition=공시가격 1억 이하');
      },
    },
    {
      label: '지분경매',
      imgSrc: '/assets/images/main/icon_share.svg',
      onClick: () => {
        navigate('/search?type=c&specialCondition=지분입찰 물건');
      },
    },
    {
      label: '반값NPL',
      imgSrc: '/assets/images/main/icon_nplsale.svg',
      onClick: () => {
        navigate('search?type=c&specialCondition=반값 NPL물건');
      },
    },
    {
      label: '반값경매',
      imgSrc: '/assets/images/main/icon_auctionsale.svg',
      onClick: () => {
        navigate('/search?type=c&specialCondition=반값 경매물건');
      },
    },
    {
      label: '반값공매',
      imgSrc: '/assets/images/main/icon_publicsale.svg',
      onClick: () => {
        navigate('/search?type=c&specialCondition=반값 공매물건&type=p');
      },
    },
    {
      label: 'HUG인수조건변경',
      name1: 'HUG',
      name2: '인수조건변경',
      imgSrc: '/assets/images/main/icon_conditions.svg',
      onClick: () => {
        navigate('/search?type=c&specialCondition=HUG 임차권 인수조건 변경');
      },
    },
  ];

  const top = buttonData.slice(0, 6);
  const bottom = buttonData.slice(6);

  useEffect(() => {
    const el = viewportRef.current;
    if (!el) return;
    const onScroll = () => {
      const max = el.scrollWidth - el.clientWidth;
      setProgress(max > 0 ? el.scrollLeft / max : 0);
    };
    el.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => el.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Section>
      <CategoryContainer ref={viewportRef}>
        <Container>
          {top.map((item) => (
            <CategoryButton key={item.label} onClick={item.onClick}>
              <CategoryIcon>
                <img src={item.imgSrc} alt="" draggable={false} />
              </CategoryIcon>
              <CategoryLabel>{item.label}</CategoryLabel>
            </CategoryButton>
          ))}
        </Container>
        <Container>
          {bottom.map((item) => (
            <CategoryButton key={item.label} onClick={item.onClick}>
              <CategoryIcon>
                <img src={item.imgSrc} alt="" draggable={false} />
              </CategoryIcon>
              <CategoryLabel>{item.label}</CategoryLabel>
            </CategoryButton>
          ))}
        </Container>
      </CategoryContainer>

      <Indicator>
        <Track>
          <Thumb style={{ ['--p' as any]: progress } as React.CSSProperties} />
        </Track>
      </Indicator>
    </Section>
  );
};

export default FillterButton;

const Section = styled.div`
  display: flex;
  width: 100%;
  padding: 24px 16px;
  flex-direction: column;
  align-items: flex-start;
`;

const CategoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  width: 100%;
  flex: 0 0 100%;
`;

const CategoryButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex: 0 0 25%;
  min-width: 0;
`;

const CategoryIcon = styled.div`
  display: flex;
  padding: 7px;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  background: rgba(2, 32, 71, 0.05);
`;

const CategoryLabel = styled.div`
  white-space: nowrap;
  align-self: stretch;
  color: #6b7684;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const Indicator = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin-top: 17px;
`;

const Track = styled.div`
  width: 40px;
  height: 4px;
  border-radius: 4px;
  background: rgba(2, 32, 71, 0.05);
  position: relative;
`;

const Thumb = styled.div`
  --thumb-w: 20px;
  position: absolute;
  top: 0;
  left: 0;
  width: var(--thumb-w);
  height: 100%;
  border-radius: 4px;
  background: #616161;

  transform: translateX(calc((54px - var(--thumb-w)) * var(--p, 0)));
  transition: transform 120ms linear;
`;
